import { useEffect, useRef } from 'react';
import { useAppSelector } from '@/state/store';
import ProcessFilesContent from '@/components/smartai/ProcessFiles/ProcessFilesContent';
import { AddRepositoryBackButton } from './AddRepositoryPickPanel';
import { useProcessFilesScan } from './useProcessFilesScan';

type AddRepositoryScanPanelProps = {
  onBack: () => void;
  onComplete: (elapsedTime: string) => void;
};

const AddRepositoryScanPanel = ({
  onBack,
  onComplete,
}: AddRepositoryScanPanelProps) => {
  const { org, repoName, branchName, repoUrl, azureProject } = useAppSelector(
    state => state.onboarding,
  );
  const startedRef = useRef(false);

  const { processFiles, processing, progress, elapsedTime, error, filesCount } =
    useProcessFilesScan({ onComplete });

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    void processFiles();
  }, [processFiles]);

  return (
    <div className="flex h-full min-h-0 flex-col bg-[var(--inv-bg)]">
      <div className="min-h-0 flex-1 overflow-y-auto">
        <div className="px-8 pt-8 max-[520px]:px-5">
          <AddRepositoryBackButton onBack={onBack} />
        </div>
        <ProcessFilesContent
          embedded
          filesCount={filesCount}
          repoUrl={repoUrl}
          branchName={branchName}
          processing={processing}
          progress={progress}
          elapsedTime={elapsedTime}
          error={error}
          org={org}
          project={azureProject}
          repoName={repoName}
        />
      </div>
    </div>
  );
};

export default AddRepositoryScanPanel;
